<div [formGroup]="form" class="datefilter">
  <div>
    <div *ngIf="form && isOk4Load === true">
      <date-picker
        id="dpStartDate"
        name="StartDate"
        [group]="form"
        [label]="'ClientApp.Review.ReviewCard.DateFilterReview.StartDate' | translate"
        [required]="false"
        textType="date"
        [disabled]="false">
      </date-picker>
    </div>
    <div *ngIf="service.includeTime">
      <time-picker name="StartTime" [group]="form" required="false" [disabled]="false" [showSeconds]="false"> </time-picker>
    </div>
  </div>
  <div>
    <div *ngIf="form">
      <date-picker
        id="dpEndDate"
        name="EndDate"
        [group]="form"
        [label]="'ClientApp.Review.ReviewCard.DateFilterReview.EndDate' | translate"
        [required]="false"
        textType="date"
        [disabled]="false">
      </date-picker>
    </div>
    <div *ngIf="service.includeTime">
      <time-picker name="EndTime" [group]="form" required="false" [disabled]="false" [showSeconds]="false"> </time-picker>
    </div>
  </div>
  <div *ngIf="hasIncludeTime" class="includetime">
    <span>{{ "ClientApp.Review.ReviewCard.DateFilterReview.IncludesClockFilter" | translate }}</span>
    <ssg-swichbox (valueChange)="service.includeTime = !service.includeTime; applyFilter()" [check]="service.includeTime">{{
      "ClientApp.Review.ReviewCard.DateFilterReview.IncludesClockFilter" | translate
    }}</ssg-swichbox>
  </div>
</div>
